import settings from 'src/config/settings'

export const PARTNER_STATUS_ENDPOINT = `${settings.httpsServices.onboarding}/api/v1/partner-status`
